/**
 * Created by Hande on 4/25/2017.
 */
Vivense.init['cartProductList'] = Vivense.init['cartProductList'] || [];

window.viveCartProductList = window.viveCartProductList || {};

function updateFabricInfoText(productComponents, fabricInfo,quantity) {
    var componentFabricInfo;
    if (productComponents !== "") {
        var fabricInfoByComponents = fabricInfo.value.split(" | ");
        fabricInfo.value = "";
        fabricInfo.value = "Kumaş Bilgisi:  "

        fabricInfoByComponents.forEach(function (fabric,index) {
            componentFabricInfo = fabric.split("Adet")[1];
            if (componentFabricInfo !== undefined) {
                fabricInfo.value += quantity + " Adet " + componentFabricInfo;
                if(index != fabricInfoByComponents.length-1){
                    fabricInfo.value +=  " | ";
                }

            }
        })

    } else {
        componentFabricInfo = fabricInfo.value.split("Adet")[1];
        fabricInfo.value = "Kumaş Bilgisi: " + quantity + " Adet " + componentFabricInfo + " | ";
    }

}


Vivense.init['cartProductList'].push(function() {

    var _etmc = [];

    var checkoutForm = $("#checkoutForm");
    var orderPreview = $(".order-preview");

    var checkCouponResultCodes = {
        FAIL : 0,
        SUCCESS : 1,
        EMPTY_COUPON : 2,
        BANK_BASED_COUPON : 3,
        USER_BASED_COUPON : 4,
        EMAIL_BASED_COUPON : 5
    };

    var blockUIOpts = {
        // message: '<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>',
        message: '<div class="vivense-loading-icon"><img src="/img/page-loading-vivense-logo.svg"></div>',
        fadeIn: 150,
        fadeOut: 50,
        css : {
            border: 'none',
            backgroundColor: 'none'
        },
        overlayCSS : {
            backgroundColor: '#fff',
            opacity: 0.6,
            cursor: null,
            color: '#fff'
        }
    };



    function blockUI() {
        checkoutForm.block(blockUIOpts);
    }

    function unblockUI() {
        checkoutForm.unblock(blockUIOpts);
    }

    function forceRepaint(checkoutForm) {
        if ( ! checkoutForm || checkoutForm.length == 0) {
            return;
        }

        var domElement = checkoutForm.get(0);

        domElement.style.display = 'none';
        domElement.offsetHeight;
        domElement.style.display = '';
    }





    window.viveCartProductList.cartComfirm = function() {

        var noteArea = $(".note-textarea");
        var note = '';

        if(noteArea.length > 0){
            note = noteArea.val();
        }

        $.ajax({
            url: '/index.php?option=com_virtuemart&nosef=1&view=cart&task=checkoutProductList',
            noCache: true,
            method: 'post',
            data: 'customer_comment=' + note,
            success: function (json, text) {

                var data = JSON.parse(json);

                if (!data.success) {

                    if (data.message != '') {
                        $.jAlert({
                            'title': '&nbsp;',
                            'content': '<span>' + data.message + '</span>',
                            'theme': 'default',
                            'size': 'sm',
                            'showAnimation': 'fadeIn',
                            'hideAnimation': 'fadeOut',
                            'btns': [{'text': 'TEKRAR DENEYİNİZ', 'id': 'cancel-id'}]
                        });
                    }

                    return false;
                }


                if(window.userId != 0){
                    window.location = "/adres-listesi.html";
                }
                else{
                    window.location.href = '/vivense-uye-kayit.html?ref=basket';

                    $(".modal-register-close").text("ÜYE OLMADAN DEVAM ET");
                    $(".modal-register-close").addClass("basket_cta");
                    $(".register_popup_top_text").hide();
                    $(".popup-action-title").removeClass("active-tab");
                    $(".register-title").addClass("active-tab");
                    Vivense.loginPopup.open("basket_cta");
                }

            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {

                $.jAlert({
                    'id': 'isTOSAcceptedAlert',
                    'title': '&nbsp;',
                    'content': 'Sepeti Onaylarken Bir Hata Oluştu Lütfen Sayfayı Yenileyip Tekrar Deneyiniz!',
                    'theme': 'default',
                    'size': 'sm',
                    'showAnimation': 'fadeIn',
                    'hideAnimation': 'fadeOut',
                    'btns': [{
                        'text': 'TAMAM', 'closeAlert': true, 'id': 'cancel-id'
                    }]
                });

            }

        });

        return false;
    };



    window.viveCartProductList.getPartial = function(){

        $.ajax('/ajax/cart/partialCartProductList.php', {
            method: 'GET'
        })
            .done(function (response, textStatus, jqXHR) {
                //responseData sadece html olmyacak succes bilgisi atılacak.ü

                if (response.livingProductCount < 2){
                    $('.living-area').hide();
                }

                window.viveCartProductList.displayPartial(response.data);
            })
            .fail(
                function(){
                    $.jAlert({
                        'id': 'isTOSAcceptedAlert',
                        'title': '&nbsp;',
                        'content': 'Sayfa Bilgileri Güncellenirken Bir Hata Oluştu! Lütfen Sayfayı Yenileyiniz!',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{
                            'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                    });
                }

            );

    };

    window.viveCartProductList.displayPartial = function (data) {

        if(data.productsNeedingAssembly !== undefined){
            window.productsNeedingAssembly = data.productsNeedingAssembly;
        }

        var keyArray = [];

        var calculate_margin = $('#calculate_margin');


        if(Object.keys(data.productLines).length === 0){
            /* Personaclick: Update the current cart */
            //personaclick("track", "cart", []);

            location.reload();
        }
        else{

            orderPreview.empty();
            $(".order-preview").html(data.cartCostInfo);
            $(".basket_product_list_header").replaceWith(data.topAlert);
            $(".admin-content").replaceWith(data.cartAdminContent);
            $("#promotion-info").html(data.promotionInfo);
            $("#available-promotions-area").html(data.availablePromotions);
            $(".cart-header").replaceWith(data.cartHeader);


            $.each(data.productLines,function(key,line){

                var div =  $(".cart-inside[data-key='" + key + "']");
                div.replaceWith(line);


                keyArray.push(key);
            });

            $('.cart-inside').each(function(){
                var key = $(this).data("key");

                if($.inArray(key.toString(),keyArray) === -1){

                    $(this).remove();

                    var noteDiv = $("#product_note_div[data-key='" + key + "']");

                    if(noteDiv.length > 0){
                        noteDiv.remove();
                    }
                }
            });

            var cardProductsForEvent = [];
            $('.cart-inside').each(function(){
                cardProductsForEvent.push({
                    id: $(this).data("sku"),
                    amount: parseInt($(this).find('.add_qty_cart').val())
                });
            });

            /* Personaclick: Update the current cart */
            //personaclick("track", "cart", cardProductsForEvent);
        }


        var priceCalc = $(".pricecalc");

        calculate_margin.attr("data-totalprice",priceCalc.data("order-total")+priceCalc.data("assembly-price"));
        calculate_margin.attr("data-totaleffectivecogs",priceCalc.data("totaleffectivecogs"));
        calculate_margin.attr("data-discount",priceCalc.data("discount"));


        if(data.couponCode !== "")
        {
            $("#coupon-code-text").html(data.couponCode);
            $("#coupon-discount-text").html(data.discount);
            if(data.discount > 0){
                $(".vvns-discount-coupon-area__title").show();
            }
            else {
                $(".vvns-discount-coupon-area__title").hide();
            }
            $(".vvns-discount-coupon-area__card").show();
            $(".vvns-discount-coupon-area__coupon-input").hide();
        }
        else{
            $(".vvns-discount-coupon-area__card").hide();
            $("#coupon_code").val("");
            $(".vvns-discount-coupon-area__coupon-input").show();
        }

        window.viveCartProductList.initAvailablePromotionsSwipe();
        window.viveCartProductList.bindEvents();
        window.viveCartProductList.calculateMargin();
        window.viveCartProductList.calculateNewMargin();
        window.viveCartProductList.bindAdminEvents();
        window.viveCartProductList.fireRelatedDigitalDatalayerEvent();
        window.viveCartProductList.einsteinEvents();
    };


    window.viveCartProductList.dataLayerQuantityEvent = function(element,changedQuantity){

        var variant = "";
        if(element.hasClass("cart-inside")){
            var variantElement = element.find(".product-components-inner.variant");
            if(variantElement.length){
                variant = variantElement.text().trim();
            }
        }

        var product = [{
            'id': element.data('sku'),
            'name' : element.data('name'),
            'brand' : 'Vivense',
            'category' : element.data('last-viewed-category'),
            'quantity' : Math.abs(changedQuantity),
            'price' : element.data('price'),
            'list': element.data('last-viewed-category') + ' Listing',
            'variant' : variant,
            'dimension11' : element.data('discount-rate').toString(), //Discount rate
            'dimension12' : element.data('onshowroom'), //Is there on showroom
            'dimension13' :  element.data('image-count').toString() //Number of pictures
        }];

        if(parseInt(changedQuantity) > 0 ){
            dataLayer.push({
                'Category': 'Enhanced Ecommerce',
                'Action': 'Browse',
                'Label': 'Add to Cart',
                'Value': 0,
                'noninteraction': false,
                'ecommerce': {
                    'currencyCode': 'TRY',
                    'add': {
                        'actionField': {
                            'list': element.data('last-viewed-category') + ' Listing' // Product List Type
                        },
                        'products': product
                    }
                },
                'event': 'eeEvent'
            });
        }
        else
        {
            dataLayer.push({
                'Category': 'Enhanced Ecommerce',
                'Action': 'Browse',
                'Label': 'Remove From Cart',
                'Value': 0,
                'noninteraction': false,
                'ecommerce': {
                    'currencyCode': 'TRY',
                    'remove': {
                        'actionField': {
                            'list': element.data('last-viewed-category') + ' Listing' // Product List Type
                        },
                        'products': product
                    }
                },
                'event': 'eeEvent'
            });

            /* Personaclick: Removing a product from the cart */
            //personaclick("track", "remove_from_cart", element.data('sku'));
        }
    };


    window.viveCartProductList.deleteProduct = function (productKey) {

        $('.delete-it').bind("click",function(){
            $.ajax({
                url:"/index.php?api_controller=checkout&api_ajax=remove_product&id="+productKey,
                success:function(data){

                    var response = JSON.parse(data);

                    if(response.error){
                        //uyarıyı göster TODO @erhan bakılması gerekebilir
                    }
                    else{
                        window.viveCartProductList.dataLayerQuantityEvent(
                            $(".cart-inside[data-key='" + productKey + "']"),
                            -parseInt($(".cartItemQuantity[data-pid='"+productKey+"']").val())
                        );
                        window.viveCartProductList.removeProduct(productKey);
                        window.viveCartProductList.getPartial();
                    }
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {

                    $.jAlert({
                        'id': 'isTOSAcceptedAlert',
                        'title': '&nbsp;',
                        'content': 'Ürün Sepetten Silinirken Bir Hata Oluştu!',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{
                            'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                    });

                }
            })

      });

    };

    window.viveCartProductList.initAvailablePromotionsSwipe = function (){

        var swiperItemLength = $(".promotion-slide-item").length;

        var slidesPerview = (swiperItemLength < 4 ? swiperItemLength : 3);

        var availablePromotionsSwiper  = new Swiper('.available-promotions-swipe', {
            loop: swiperItemLength >= 4,
            autoplay: true,
            slidesPerView: slidesPerview,
            slidesPerGroup: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".promotion-swiper-next",
                prevEl: ".promotion-swiper-prev",
            }
        });


    }

    window.viveCartProductList.bindEvents = function (){

        var selectBoxPreviousVal;

        $(".add_qty_cart").bind("focus",

            function(){
                selectBoxPreviousVal = this.value;
            }).change(function(){

                var selectBox = $(this),
                    quantity = selectBox.val(),
                    productKey = selectBox.data("pid"),
                    fabricInfoId = "fabric-info-"+productKey,
                    fabricInfo = document.getElementById(fabricInfoId),
                    productComponentsId = "product-components-"+productKey,
                    productComponents  = document.getElementById(productComponentsId);

                if (productComponents) {
                    productComponents = productComponents.textContent;
                }

                $.ajax({
                    url:"/index.php?api_controller=checkout&api_ajax=update_product&id="+productKey+"&quantity="+quantity,
                    cache:false,
                    success:function(data){

                        var response = JSON.parse(data);

                        if(response.error){

                            if(response.message != ''){
                                $.jAlert({
                                    'title': '&nbsp;',
                                    'content': '<span>'+response.message+'</span>',
                                    'theme': 'default',
                                    'size': 'sm',
                                    'showAnimation': 'fadeIn',
                                    'hideAnimation': 'fadeOut',
                                    'btns':  [ {'text': 'TEKRAR DENEYİNİZ','id':'cancel-id'}]
                                });
                            }

                            selectBox.val(selectBoxPreviousVal);

                            window.viveCartProductList.getPartial();
                        }
                        else{
                            selectBox.val(quantity);
                            viveCartProductList.dataLayerQuantityEvent(
                                $(".cart-inside[data-key='" + productKey + "']"),
                                quantity-selectBoxPreviousVal
                            );
                            selectBoxPreviousVal = quantity;
                            window.viveCartProductList.getPartial();

                            if (fabricInfo != null && fabricInfo != undefined && fabricInfo.value !== "") {
                                updateFabricInfoText(productComponents, fabricInfo,quantity);
                            }
                        }

                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {

                        $.jAlert({
                            'id': 'isTOSAcceptedAlert',
                            'title': '&nbsp;',
                            'content': 'Ürün Sayısı Güncellenirken Bir Hata Oluştu!',
                            'theme': 'default',
                            'size': 'sm',
                            'showAnimation': 'fadeIn',
                            'hideAnimation': 'fadeOut',
                            'btns': [{
                                'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                        });

                    }
                 })
            });

        $('.remove_from_cart-fake').bind("click",function(){

            $.jAlert({
                'title': '&nbsp;',
                'content': 'Ürünü sepetinizden silmek istediğinize emin misiniz?',
                'theme': 'default',
                'size': 'sm',
                'showAnimation': 'fadeIn',
                'hideAnimation': 'fadeOut',
                'btns':  [ {'text': 'VAZGEÇ','id':'cancel-id'}, {'text': 'SİL','class':'delete-it','id':'delete-id'} ]
            });

            var productKey = $(this).data("pid");
            window.viveCartProductList.deleteProduct(productKey);
            return false;

        });

        $('.stock-sale-span').on('click', function(event){

            var showroom_list = jQuery('#showroom_list');
            if(showroom_list.val() == 'default'){
                showroom_list.css('border-color', 'red');
                return false;
            }

            var showroomSale = $(this).parent("label").children("input.stock-sale-checkbox");

            var showroom = $( "#showroom_list option:selected" ).data('store').split(' Showroom');
            var showroomId = $( "#showroom_list option:selected" ).val();

            event.preventDefault();

            if(showroomSale.attr("checked")){

                $.ajax({
                    url :'index.php?api_controller=checkout&api_ajax=disableSaleLocation',
                    noCache : true,
                    method : 'post',
                    data :'productKey='+showroomSale.data("product"),
                    success : function(json,text) {

                        showroomSale.trigger("click");
                        showroomSale.attr("checked",false);
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {

                        $.jAlert({
                            'id': 'isTOSAcceptedAlert',
                            'title': '&nbsp;',
                            'content': 'Lokasyon Bilgisi Güncellenirken Bir Hata Oluştu!',
                            'theme': 'default',
                            'size': 'sm',
                            'showAnimation': 'fadeIn',
                            'hideAnimation': 'fadeOut',
                            'btns': [{
                                'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                        });

                    }

                });

                $('#delivery-chooses[data-product="'+ showroomSale.data("product") +'"]').hide();
                $('#delivery-chooses[data-product-status="'+ showroomSale.data("product") +'"]').hide();
                $('#delivery-chooses[data-product-status="'+ showroomSale.data("product") +'"]').find('input').attr("checked",false);

            }
            else{
                $.ajax({
                    url :'index.php?api_controller=checkout&api_ajax=setSaleLocation',
                    noCache :true,
                    method : 'post',
                    data : 'productKey='+showroomSale.data("product")+"&location="+showroom[0]+"&locationId=" + showroomId,
                    success :function(json,text) {

                        var data = JSON.parse(json);

                        if(data.error){

                            if(data.message != ''){
                                $.jAlert({
                                    'title': '&nbsp;',
                                    'content': '<span>'+data.message+'</span>',
                                    'theme': 'default',
                                    'size': 'sm',
                                    'showAnimation': 'fadeIn',
                                    'hideAnimation': 'fadeOut',
                                    'btns':  [ {'text': 'TEKRAR DENEYİNİZ','id':'cancel-id'}]
                                });
                            }
                        }
                        else{
                            showroomSale.trigger("click");
                            showroomSale.attr("checked",true);
                            $('#delivery-chooses[data-product="'+ showroomSale.data("product") +'"]').find('input').attr("checked",false);
                            $('#delivery-chooses[data-product="'+ showroomSale.data("product") +'"]').show();
                            $("#showroom_list").prop( "disabled", true );
                        }
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {

                        $.jAlert({
                            'id': 'isTOSAcceptedAlert',
                            'title': '&nbsp;',
                            'content': 'Lokasyon Bilgisi Güncellenirken Bir Hata Oluştu!',
                            'theme': 'default',
                            'size': 'sm',
                            'showAnimation': 'fadeIn',
                            'hideAnimation': 'fadeOut',
                            'btns': [{
                                'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                        });

                    }

                });
            }


        });

        $(".deleteAssembly").on("click",function () {

            var mainProductKey = $(this).data("mainproductkey");
            window.viveCartProductList.dataLayerQuantityEvent($(this), -parseInt($(this).data("quantity")));


            $.ajax({
                url:"/index.php?api_controller=checkout&api_ajax=removeAssemblyProduct&mainProductKey="+mainProductKey,
                cache:false,
                success:function(data){

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'Category': 'Cart',
                        'Action': 'Kurulum Kaldırma',
                        'Label': '',
                        'noninteraction': true,
                        'event': 'gaEvent'
                    });

                    window.viveCartProductList.getPartial();

                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {


                    $.jAlert({
                        'id': 'isTOSAcceptedAlert',
                        'title': '&nbsp;',
                        'content': 'Kurulum Çıkarılırken Bir Hata Oluştu Lütfen Daha Sonra Tekrar Deneyiniz!',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{
                            'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                    });
                }
            })
        }),

        $(document).on("click", "input.delivery-chooses-checkbox-1", function () {
            var parentDeliveryChoose = $(this).parents('.delivery-choose');
            if(parentDeliveryChoose.find('input.stock-sale-checkbox').is(':checked') && $(this).is(':checked')) {
                parentDeliveryChoose.find("input.delivery-chooses-checkbox-1").prop( "checked", false );
                $(this).prop( "checked", true );
                parentDeliveryChoose.find('.product-status-chooses').show();
            } else {
                parentDeliveryChoose.find('.product-status-chooses').hide();
                parentDeliveryChoose.find('input.delivery-chooses-checkbox-2').prop( "checked", false );
            }
        }),

        $(".addAssembly").on("click",function () {

            var mainProductKey = $(this).data("mainproductkey");
            window.viveCartProductList.dataLayerQuantityEvent($(this),parseInt($(this).data("quantity")));

            $.ajax({
                url:"/index.php?api_controller=checkout&api_ajax=addAssemblyProduct&mainProductKey="+mainProductKey,
                cache:false,
                success:function(data){

                    window.viveCartProductList.getPartial();

                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {


                    $.jAlert({
                        'id': 'isTOSAcceptedAlert',
                        'title': '&nbsp;',
                        'content': 'Kurulum Eklenirken Bir Hata Oluştu Lütfen Daha Sonra Tekrar Deneyiniz!',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{
                            'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                    });
                }
            })

        });


        $(".promotion-usage-checkbox").on("click",function () {

            var postData = {
                token:window.formToken,
                usagePromotion : $(this).is(':checked') ? 1 : 0
            }

            $.ajax('/index.php?option=com_virtuemart&nosef=1&view=cart&task=changePromotionUsage', {

                method: 'POST',
                data: postData

            }).done(function (data) {

                window.viveCartProductList.getPartial();

            });

        });

    };

    window.viveCartProductList.showEmailAlert = function(couponCode){

        $.jAlert({
            'id': '',
            'title': '&nbsp;',
            'content': '<span class="coupon-alert-text">Bu kuponu kullanabilmek için email adresinizi girmelisiniz.</span><br><br><input id="email_input" name="email_input" type="email">',
            'theme': 'default',
            'size': 'sm',
            'showAnimation': 'fadeIn',
            'hideAnimation': 'fadeOut',
            'btns': [{
                'text': 'TAMAM', 'id': 'cancel-id','closeAlert':true ,'onClick': function (e,btn) {
                    var email = $('#email_input').val();
                    if(email) {
                        window.viveCartProductList.checkCoupon(couponCode,email);
                    }
                    $( "body" ).off('click', '#cancel-id');
                }}]
        });

    };


    window.viveCartProductList.showEmailWarning = function() {

        $.jAlert({
            'id': 'coupon-apply-alert-invalid',
            'title': '&nbsp;',
            'content': '<span class="coupon-alert-text">Bu kuponu kullanabilmek için üye olmanız gerekmektedir.</span>',
            'theme': 'default',
            'size': 'sm',
            'showAnimation': 'fadeIn',
            'hideAnimation': 'fadeOut',
            'btns': [{
                'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id', 'onClick': function (e,btn){
                    Vivense.loginPopup.open();
                    $( "body" ).off('click', '#cancel-id');
                } }]
        });
    };


    window.viveCartProductList.checkoutProductList = function(){
        if(window.productsNeedingAssembly && window.productsNeedingAssembly.length > 0){
            var listContainer = $("#checkoutWarningProductList");
            listContainer.empty();
            $("#checkout-warning-item-template .checkout-warning-checkbox").prop("checked", false).removeAttr("checked");

            $.each(window.productsNeedingAssembly, function(i, product){
                var item = $("#checkout-warning-item-template").children().first().clone();
                item.removeClass("selected");
                item.find(".checkout-warning-checkbox")
                    .attr("data-product-key", product.key)
                    .prop("checked", false)
                    .removeAttr("checked");
                item.find(".checkout-warning-product-img").attr("src", product.image);
                item.find(".checkout-warning-product-name").text(product.name);
                item.find(".checkout-warning-product-assembly").text("Kurulum: " + product.assemblyPrice + " TL");
                listContainer.append(item);
            });

            window.viveCartProductList.updateContinueButton();
            $("#cart-checkout-warning-modal").addClass("open");
        } else {
            window.viveCartProductList.cartComfirm();
        }
    };

    window.viveCartProductList.updateContinueButton = function(){
        var checkedCount = $("#checkoutWarningProductList .checkout-warning-checkbox:checked").length;
        var btn = $("#checkoutWarningModalContinue");
        if(checkedCount > 0){
            btn.text(checkedCount + " ADET KURULUM EKLE VE DEVAM ET");
        } else {
            btn.text("EKLEMEDEN DEVAM ET");
        }
    };

    $(document).on("change", ".checkout-warning-checkbox", function(){
        var item = $(this).closest(".checkout-warning-product-item");
        if($(this).is(":checked")){
            item.addClass("selected");
        } else {
            item.removeClass("selected");
        }
        window.viveCartProductList.updateContinueButton();
    });

    $(document).on("click", ".checkout-warning-product-item", function(e){
        if($(e.target).hasClass("checkout-warning-checkbox")) return;
        var checkbox = $(this).find(".checkout-warning-checkbox");
        checkbox.prop("checked", !checkbox.prop("checked")).trigger("change");
    });

    $(document).on("click", "#checkoutWarningModalContinue", function(){
        var btn = $(this);
        if(btn.prop("disabled")) return;

        var selectedKeys = [];
        $("#checkoutWarningProductList .checkout-warning-checkbox:checked").each(function(){
            selectedKeys.push($(this).data("product-key"));
        });

        if(selectedKeys.length === 0){
            $("#cart-checkout-warning-modal").removeClass("open");
            window.viveCartProductList.cartComfirm();
            return;
        }

        var originalHtml = btn.html();
        btn.prop("disabled", true).html('<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>');

        $.ajax({
            url: "/index.php?api_controller=checkout&api_ajax=addAssemblyProduct&mainProductKeys=" + selectedKeys.join(","),
            cache: false,
            success: function(){
                $("#cart-checkout-warning-modal").removeClass("open");
                window.viveCartProductList.cartComfirm();
            },
            error: function(){
                btn.prop("disabled", false).html(originalHtml);
                $.jAlert({
                    'id': 'isTOSAcceptedAlert',
                    'title': '&nbsp;',
                    'content': 'Kurulum Eklenirken Bir Hata Oluştu Lütfen Daha Sonra Tekrar Deneyiniz!',
                    'theme': 'default',
                    'size': 'sm',
                    'showAnimation': 'fadeIn',
                    'hideAnimation': 'fadeOut',
                    'btns': [{
                        'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                });
            }
        });
    });

    $(document).on("click", "#checkoutWarningModalCancel, #closeCheckoutWarningModal, #cart-checkout-warning-modal .vivense-modal-overlay", function(){
        $("#cart-checkout-warning-modal").removeClass("open");
    });

    function number_format(number){
        var locale = 'tr';
        var options = {minimumFractionDigits: 0, maximumFractionDigits: 0};
        var formatter = new Intl.NumberFormat(locale, options);

        return formatter.format(number);
    }



    window.viveCartProductList.deleteCart = function(){

        $.ajax('/index.php?option=com_virtuemart&nosef=1&view=cart&task=deleteCart', {

            method: 'POST',
            data:'token='+window.formToken

        }).done(function (data) {

            var response = JSON.parse(data);

            if(response.error){
                if(response.msg != ''){
                    $.jAlert({
                        'title': '&nbsp;',
                        'content': '<span>'+response.msg+'</span>',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns':  [ {'text': 'TAMAM','id':'cancel-id'}]
                    });
                }
            }
            else {
                window.viveCartProductList.getPartial();
            }

        }).fail(
            function() {

                $.jAlert({
                    'id': 'isTOSAcceptedAlert',
                    'title': '&nbsp;',
                    'content': 'Ürünler Silinirken Bir Hata Oluştu Lütfen Sayfayı Yenileyip Tekrar Deneyiniz!',
                    'theme': 'default',
                    'size': 'sm',
                    'showAnimation': 'fadeIn',
                    'hideAnimation': 'fadeOut',
                    'btns': [{
                        'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                });
            }
        );

    };

    window.viveCartProductList.einsteinEvents = function(){
        var einsteinProductListArray = [];
        $('div[id*=product_row]').each(function( index ) {
            var item = {
                "item": $(this).data('sku').toString(),
                "quantity" : $(this).find('select[id*=quantity_]').val(),
                "price" : $(this).data('price').toString(),
                "unique_id" : $(this).data('key').toString()
            }
            einsteinProductListArray.push(item) 
        });

         _etmc.push(["setOrgId", "510002161"]);
         _etmc.push(["trackCart", { "cart":  einsteinProductListArray }]);
         

    };
 
    $(document).ajaxStart(function(){
        blockUI();
    });

    $(document).ajaxStop(function() {
        unblockUI();
    });


    function showCouponPopUp(popUpId,message){
        $.jAlert({
            'id': 'coupon-apply-alert-invalid',
            'title': '&nbsp;',
            'content': '<span class="coupon-alert-text">'+message+'</span>',
            'theme': 'default',
            'size': 'sm',
            'showAnimation': 'fadeIn',
            'hideAnimation': 'fadeOut',
            'btns': [{
                'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
        });
    }

    window.viveCartProductList.checkCoupon = function (couponCode,email)
    {
        $.ajax({
            url:"/index.php?api_controller=checkout&api_ajax=check_coupon",
            method:"post",
            data:"coupon="+couponCode+'&emailAddress='+email,
            success:function(data){

                var result = JSON.parse(data);

                switch (result.status) {
                    case checkCouponResultCodes.EMPTY_COUPON :
                        window.viveCartProductList.getPartial();
                        break;
                    case checkCouponResultCodes.FAIL :
                    case checkCouponResultCodes.BANK_BASED_COUPON :
                        if(result.subMessage !== "")
                        {
                            result.message = result.message +"<br><small>"+result.subMessage+"</small>";
                        }
                        showCouponPopUp('coupon-apply-alert-invalid',result.message);

                        if(result.status === checkCouponResultCodes.BANK_BASED_COUPON){
                            window.viveCartProductList.getPartial();
                        }
                        break;
                    case checkCouponResultCodes.EMAIL_BASED_COUPON :
                        window.viveCartProductList.showEmailAlert(couponCode);
                        break;
                    case checkCouponResultCodes.USER_BASED_COUPON :
                        window.viveCartProductList.showEmailWarning();
                        break;
                    case checkCouponResultCodes.SUCCESS :
                        showCouponPopUp('coupon-apply-alert-valid',result.message);
                        window.viveCartProductList.getPartial();
                        break;
                    default :
                        break;
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                showCouponPopUp('isTOSAcceptedAlert',"Kupon Kodu Kontrol Edilirken Bir Hata Oluştu!");
            }
        })
    }

    $('#coupon_code_button').bind("click",function(){

        var couponCode = $("#coupon_code").val();

        window.viveCartProductList.checkCoupon(couponCode,"");
    });

    $('#remove-coupon-button').bind("click",function(){

        var couponCode = "";

        window.viveCartProductList.checkCoupon(couponCode,"");
    });

    $('.delete-cart-btn').on('click', function(){

        window.viveCartProductList.deleteCart();
    });

    window.viveCartProductList.checkCustomerPromotionEmail = function (promotionEmail) {
        var postData = {
            promotionEmail: promotionEmail
        }

        $.ajax({
            url: "/index.php?api_controller=checkout&api_ajax=check_promotion_email",
            method: "post",
            data: postData,
            success: function (data) {

                var response = JSON.parse(data);

                if (response.error) {

                    if (response.message !== '') {
                        $.jAlert({
                            'title': '&nbsp;',
                            'content': '<span>' + response.message + '</span>',
                            'theme': 'default',
                            'size': 'sm',
                            'showAnimation': 'fadeIn',
                            'hideAnimation': 'fadeOut',
                            'btns': [{'text': 'TEKRAR DENEYİNİZ', 'id': 'cancel-id'}]
                        });
                    }
                } else {
                    window.viveCartProductList.getPartial();
                }
            },
            error: function () {

                $.jAlert({
                    'id': 'isTOSAcceptedAlert',
                    'title': '&nbsp;',
                    'content': 'Promosyon Uygulanırken Bir Hata Oluştu!',
                    'theme': 'default',
                    'size': 'sm',
                    'showAnimation': 'fadeIn',
                    'hideAnimation': 'fadeOut',
                    'btns': [{
                        'text': 'TAMAM', 'closeAlert': true, 'id': 'cancel-id'
                    }]
                });

            }
        })
    }

    $('#promotion_email_button').bind("click",function(){

        var email = $("#promotion_email").val();

        window.viveCartProductList.checkCustomerPromotionEmail(email);
    });

    $('#remove-promotion-email-button').bind("click",function(){
        $("#promotion_email").val("");
        var email = "";

        window.viveCartProductList.checkCustomerPromotionEmail(email);
    });

    window.viveCartProductList.bindEvents();
    window.viveCartProductList.initAvailablePromotionsSwipe();

    $(document).on("click", "#registerFromBasketBanner", function () {
        $(".login-form-slide-box").removeClass("slide-register");
        $(".user-action-wrapper").removeClass("popup-active");
        $(".popup-action-title").removeClass("active-tab");
        $(".register-switch").addClass("active-tab");
        $(".register_popup_top_text").hide();
        $(".basket-register-text").show();

        window.location.href = '/vivense-uye-kayit.html?ref=basket';

        $(".modal-register-close").text("ÜYE OLMADAN DEVAM ET");
        $(".modal-register-close").removeClass("basket_cta");

        $(".countdown-text").show();
        $(".registration-text").hide();



    });



    $(document).on("click", "#loginFromBasketBanner", function () {
        $(".login-form-slide-box").addClass("slide-register");
        $(".user-action-wrapper").removeClass("popup-active");
        $(".popup-action-title").removeClass("active-tab");
        $(".login-switch").addClass("active-tab");
        $(".register_popup_top_text").hide();
        $(".basket-register-text").show();


        window.location.href = '/vivense-uye-kayit.html?ref=basket';

        $(".modal-register-close").text("ÜYE OLMADAN DEVAM ET");
        $(".modal-register-close").removeClass("basket_cta");

        $(".countdown-text").show();
        $(".registration-text").hide();



    });

    $(".modal-register-close").on("click", function () {

        $(this).removeAttr("data-dismiss");
        $(".modal").css("z-index","-1");

        if($(this).hasClass("basket_cta")){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'Category': 'Cart',
                'Action': 'Üye Olmadan Devam Et',
                'Label': '',
                'noninteraction': true,
                'event': 'gaEvent'
            });
            Vivense.populate.insertEvent("", window.currentPage, "basket_cta", "membership", 3);
        }else{
            Vivense.populate.insertEvent("", window.currentPage, "basket_banner", "membership", 3);
        }

        window.viveCartProductList.cartComfirm();

    });

    $(".cart-confirm").on("click", function () {

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Cart',
            'Action': 'Sepeti Onayla',
            'Label': '',
            'noninteraction': true,
            'event': 'gaEvent'
        });

        $(".register_popup_top_text").hide();
        $(".registration-text").hide();
    });

    $(".continue-shopping-btn").on("click", function (e) {
        e.preventDefault();
        
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Cart',
            'Action': 'Alışverişe Devam',
            'Label': '',
            'noninteraction': true,
            'event': 'gaEvent'
        });

        window.history.go(-1);
    });



    $("#orderNoteTextareaHeader").click(function(){
        $(this).toggleClass("orderNoteTextareaActive");
        $(".orderNoteTextarea").toggle("active");
    });

    $("#orderCouponInputHeader").click(function(){
        $(this).toggleClass("orderCouponInputHeaderActive");
        $(".orderCouponInput").toggle("active");
    });

    $(".order-showroom").click(function () {
        $(this).toggleClass('cuponShowroomActiveSelect');
    });

    $('#showroom_list').on('change', function () {
        $(this).css('border-color', '#ececec');
    });


    function setCookie(name, value, expires) {
        var curCookie = name + "=" + value +
            ((expires) ? "; expires=" + expires.toGMTString() : "");
        document.cookie = curCookie + ";path=/";
    }

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    if(getCookie('einsteinIntegrationEmail') === undefined && window.userEmail !== undefined ){
        _etmc.push(["setOrgId", "510002161"]);
        _etmc.push(["setUserInfo", {"email": window.userEmail}]);
        _etmc.push(["trackPageView"]);
        setCookie('einsteinIntegrationEmail',window.userEmail,new Date(2999, 0, 0))
    } else if(getCookie('einsteinIntegrationEmail') !== undefined) {
        if(getCookie('einsteinIntegrationEmail') !== window.userEmail){
            _etmc.push(["setOrgId", "510002161"]);
            _etmc.push(["setUserInfo", {"email": window.userEmail}]);
            _etmc.push(["trackPageView"]);
            setCookie('einsteinIntegrationEmail',window.userEmail,new Date(2999, 0, 0))
        }
    }


    //Popup start

    setTimeout(function() {
        $('#overlay').modal('show');
    }, 45000);

    
    $(document).on("click",".js-close-cart-banner",function() {
        $(this).parent().hide();
    });

    $('#headingOne').on("click", function () {
        $('.vvns-promotion-info__title').toggleClass('rotate-arrow');
    });


    window.viveCartProductList.loadCityDistricts = function(combobox_id, option_text, id, type, isAsync) {

        $.ajax('/ajax/management/cityDistrictLoader.php?type=' + type + '&id=' + id, {
            method: 'GET',
            async:isAsync,
            global : false,
            fail: function(){

                return false;
            },
        }).done(function (response) {
            if (response.status) {
                var select = $('#' + combobox_id);

                $('option', select).remove();
                var option = new Option(option_text, "");
                select.append($(option));

                $.each(response.body, function (key,val) {
                    var option =  $('<option>').val(key).attr('data-id',val.id).text(key);
                    option.appendTo(select);
                });
                return true;
            } else {

                return false;
            }
        });
        return false;
    }


    window.viveCartProductList.setCityDistrict = function(city,district){

        window.dataLayer.push({
            event: "location_selection",
            action: city,
            label: district,
            event_action: "Guest"
        });
        var postData = {
            token:window.formToken,
            city : city,
            district : district
        }

        $.ajax('/index.php?option=com_virtuemart&nosef=1&view=cart&task=setCityDistrict', {

            method: 'POST',
            data:postData

        }).done(function () {
            window.viveCartProductList.getPartial();
        });

    };


    $(document).ready(function () {

        window.viveCartProductList.fireRelatedDigitalDatalayerEvent();

        if($("#guest-city-list-select").length > 0 && $("#guest-city-list-district").length > 0){
            var guestCitySelect = $("#guest-city-list-select");
            var guestDistrictSelect = $("#guest-city-list-district");

            window.viveCartProductList.loadCityDistricts(guestCitySelect.attr("id"),"İl Seçin",null,null,false);
            guestCitySelect.val(guestCitySelect.data("selected-value"));

            if(guestCitySelect.val() !== ""){
                window.viveCartProductList.loadCityDistricts(guestDistrictSelect.attr("id"),"İlçe Seçin",guestCitySelect.find(':selected').data('id'),"county",false);
                guestDistrictSelect.val(guestDistrictSelect.data("selected-value"));
            }

            guestCitySelect.on("change",function (){
                window.viveCartProductList.loadCityDistricts(guestDistrictSelect.attr("id"),"İlçe Seçin",guestCitySelect.find(':selected').data('id'),"county",false);
            });

            guestDistrictSelect.on("change",function (){
                window.viveCartProductList.setCityDistrict(guestCitySelect.val(),guestDistrictSelect.val());
            });

        }

        $(".address-list-item-span").on("click",function (){

            var selectedElement = $(this);


            if(selectedElement.hasClass("selected-address")){
                return;
            }

            var addressId = selectedElement.data("id");

            $.ajax('/index.php?option=com_virtuemart&nosef=1&view=cart&task=setSelectedAddress', {

                method: 'POST',
                data: "addressId="+addressId+'&addressType=ST&token='+window.formToken

            }).done(function (data) {
                selectedElement.parent().parent().parent().children(".selected-address-info").children(".address-name").html(selectedElement.data("address-name"));
                selectedElement.parent().parent().parent().children(".selected-address-info").children(".address-detail").html(selectedElement.data("city-district"));
                selectedElement.parent().parent().parent().children(".selected-address-info").children(".address-detail").removeClass("address-detail-empty");

                selectedElement.parent().children(".selected-address").removeClass("selected-address");
                selectedElement.addClass("selected-address");

                const citydistrict = selectedElement.data("city-district").split("/");

                window.viveCartProductList.getPartial();
                
                window.dataLayer.push({
                    event: "location_selection",
                    action: citydistrict[0] ? citydistrict[0].trim() : null,
                    label: citydistrict[1] ? citydistrict[1].trim() : null,
                    event_action: "Auth"
                });
            }).fail(

                function(){

                    $.jAlert({
                        'id': 'isTOSAcceptedAlert',
                        'title': '&nbsp;',
                        'content': 'İstek Şu An Gerçekleştirilemiyor!',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{
                            'text': 'TAMAM', 'closeAlert':true, 'id': 'cancel-id'}]
                    });
                }
            );
        });

    });


    window.viveCartProductList.fireRelatedDigitalDatalayerEvent = function (){

        var relatedDigitalProducts = [];

        $('.cart-inside').each(function(){
            relatedDigitalProducts.push({
                id: $(this).data("sku"), // Required
                price: $(this).data("price"), // Required
                qty: parseInt($(this).find('.add_qty_cart').val()), // Required
                brand: $(this).data("brand"), // Optional
                category: $(this).data("category"), // Optional
                item_group_id: '' // Optional
            });

            $(this).find(".has-setup").find(".operation").each(function (){
                relatedDigitalProducts.push({
                    id: $(this).data("sku"), // Required
                    price: $(this).data("price"), // Required
                    qty: $(this).data("quantity"), // Required
                    brand: $(this).data("brand"), // Optional
                    category: $(this).data("category"), // Optional
                    item_group_id: '' // Optional
                });
            })

        });

        window.dataLayer = window.dataLayer || [];

        dataLayer.push({
            event: "vlEvent",
            vl_label: "VL-CartView",
            vl_ecommerce: {
                cart: {
                    basket_id: window.formToken, // Required
                    products: relatedDigitalProducts
                }
            }
        });

    }

});


